import { toRef } from 'vue'
import useProfileStore from '@/stores/profile.store'

function useIsGlobal() {
  const profileStore = useProfileStore()
  const isGlobal = toRef(profileStore, 'isGlobal')
  return { isGlobal }
}

export default useIsGlobal
